import React, { useCallback, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Drawer, Form } from "antd";
import ClientAppointmentForm from "./client-appointment-form";

const DRAWER_WIDTH_KEY = "planOnline.health.clients.appointmentFormDrawer.width";
const MIN_WIDTH = 440;
const MAX_WIDTH = 640;
const DEFAULT_WIDTH = 480;

const clampWidth = (value) => {
  const max = typeof window === "undefined" ? MAX_WIDTH : Math.min(MAX_WIDTH, window.innerWidth);
  const n = Number(value);
  if (!Number.isFinite(n)) return DEFAULT_WIDTH;
  return Math.min(max, Math.max(MIN_WIDTH, Math.round(n)));
};

const loadWidth = () => {
  try {
    return clampWidth(localStorage.getItem(DRAWER_WIDTH_KEY) ?? DEFAULT_WIDTH);
  } catch {
    return DEFAULT_WIDTH;
  }
};

const saveWidth = (value) => {
  try {
    localStorage.setItem(DRAWER_WIDTH_KEY, String(clampWidth(value)));
  } catch {
    /* ignore */
  }
};

/**
 * Drawer добавления/изменения назначения.
 */
const ClientAppointmentFormDrawer = ({ open, idClient, item = null, onClose, onSaved }) => {
  const [form] = Form.useForm();
  const [size, setSize] = useState(loadWidth);
  const [saving, setSaving] = useState(false);

  const onResize = useCallback((next) => {
    setSize(clampWidth(next));
  }, []);

  const onResizeEnd = useCallback(
    (finalSize) => {
      const next = clampWidth(typeof finalSize === "number" ? finalSize : size);
      setSize(next);
      saveWidth(next);
    },
    [size]
  );

  const handleClose = useCallback(() => {
    if (saving) return;
    onClose?.();
  }, [saving, onClose]);

  const handleSaved = useCallback(() => {
    onSaved?.();
    onClose?.();
  }, [onSaved, onClose]);

  const title = "Назначение";

  const footer = (
    <div className="client-appointment-form-drawer__footer">
      <Button
        type="primary"
        className="client-appointment-form-drawer__save"
        loading={saving}
        onClick={() => form.submit()}
      >
        ОК
      </Button>
      <Button className="client-appointment-form-drawer__cancel" onClick={handleClose} disabled={saving}>
        Отмена
      </Button>
    </div>
  );

  return (
    <Drawer
      placement="right"
      size={size}
      maxSize={MAX_WIDTH}
      open={open}
      onClose={handleClose}
      destroyOnClose
      closable={false}
      title={title}
      rootClassName="client-appointment-form-drawer"
      footer={footer}
      maskClosable={!saving}
      keyboard={!saving}
      extra={
        <button
          type="button"
          className="client-appointment-form-drawer__close"
          aria-label="Закрыть"
          disabled={saving}
          onClick={handleClose}
        >
          <CloseOutlined />
        </button>
      }
      resizable={{
        onResize,
        onResizeEnd
      }}
    >
      {open ? (
        <ClientAppointmentForm
          form={form}
          idClient={idClient}
          item={item}
          embedded
          onCancel={handleClose}
          onSaved={handleSaved}
          onSavingChange={setSaving}
        />
      ) : null}
    </Drawer>
  );
};

export default ClientAppointmentFormDrawer;
